<span
  class="munily-avatar"
  [class.munily-avatar--small]="size === 'small'"
  [class.munily-avatar--medium]="size === 'medium'"
  [class.munily-avatar--large]="size === 'large'"
  [style.background-color]="backgroundColor || null"
>
  <img
    *ngIf="imageUrl"
    class="munily-avatar__img"
    [src]="imageUrl"
    [alt]="alt"
    [style.object-fit]="objectFit"
  />
  <span *ngIf="!imageUrl && displayInitials" class="munily-avatar__initials">
    {{ displayInitials }}
  </span>
</span>
